import './StatusLabel.scss'
import type { ComponentProps } from 'react'
import { clx } from '../clx'

export type StatusLabelTone = 'open' | 'busy' | 'done' | 'fail' | 'default'

const TONES: Readonly<Record<string, StatusLabelTone>> = {
  OPEN: 'open',
  BUSY: 'busy',
  DONE: 'done',
  FAIL: 'fail'
}

/** An upgrade-process status → tone. Exact uppercase match, as the portal's switch. */
export function statusLabelTone(status: string | null | undefined): StatusLabelTone {
  return (status && Object.hasOwn(TONES, status) && TONES[status]) || 'default'
}

export interface StatusLabelProps extends Omit<ComponentProps<'span'>, 'children'> {
  /** The raw `upgrade_process_status`; shown as-is. */
  status: string | null | undefined
}

/** Upgrade-process status chip (OPEN/BUSY/DONE/FAIL), coloured as the portal's StatusLabel. */
export function StatusLabel({ status, className, ref, ...rest }: StatusLabelProps) {
  return (
    <span
      ref={ref}
      {...rest}
      className={clx('status-label', `status-label--as-${statusLabelTone(status)}`, className)}
    >
      {status}
    </span>
  )
}
